var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V36C42 39.3137 39.3137 42 36 42H6C2.68629 42 0 39.3137 0 36V6Z",
    fill: "#E2E8F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_8816)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8984 13.8C12.8984 11.9829 14.3814 10.5 16.1984 10.5H21.5984C21.8371 10.5 22.0661 10.5948 22.2348 10.7636L28.8348 17.3636C29.0036 17.5324 29.0984 17.7613 29.0984 18V28.2C29.0984 30.0171 27.6155 31.5 25.7984 31.5H16.1984C14.3814 31.5 12.8984 30.0171 12.8984 28.2V13.8ZM16.1984 12.3C15.3755 12.3 14.6984 12.9771 14.6984 13.8V28.2C14.6984 29.0229 15.3755 29.7 16.1984 29.7H25.7984C26.6214 29.7 27.2984 29.0229 27.2984 28.2V18.9H21.5984C21.1014 18.9 20.6984 18.4971 20.6984 18V12.3H16.1984ZM22.4984 13.5728L26.0256 17.1H22.4984V13.5728ZM24.9348 22.2364C25.2863 21.8849 25.2863 21.3151 24.9348 20.9636C24.5834 20.6121 24.0135 20.6121 23.662 20.9636L19.4984 25.1272L18.3348 23.9636C17.9834 23.6121 17.4135 23.6121 17.062 23.9636C16.7106 24.3151 16.7106 24.8849 17.062 25.2364L18.862 27.0364C19.2135 27.3879 19.7834 27.3879 20.1348 27.0364L24.9348 22.2364Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_8816"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperCheck);
export default __webpack_public_path__ + "static/media/paper-check.be7a2b2df4146f0c4fbe413110aa6d9b.svg";
export { ForwardRef as ReactComponent };